import { platform } from '@/services/native-api/native-api';
import { salesforceService } from '@/services/salesforce';
import { type ReactNode, createContext, useContext, useEffect, useState } from 'react';

type SalesforceContextType = {
  isReady: boolean;
};

const SalesforceContext = createContext<SalesforceContextType | null>(null);

type SalesforceProviderProps = {
  children: ReactNode;
};

export const SalesforceProvider = ({ children }: SalesforceProviderProps) => {
  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    let isMounted = true;

    const initializeSalesforce = async () => {
      try {
        if (platform === 'web') {
          const isInitialized = await salesforceService.initialize();
          if (isMounted) {
            setIsReady(isInitialized);
          }
        }
      } catch (error) {
        console.error('[Salesforce Provider] Failed to initialize:', error);
        if (isMounted) {
          setIsReady(false);
        }
      }
    };

    initializeSalesforce();

    return () => {
      isMounted = false;
    };
  }, []);

  return <SalesforceContext.Provider value={{ isReady }}>{children}</SalesforceContext.Provider>;
};

export const useSalesforce = (): SalesforceContextType => {
  const context = useContext(SalesforceContext);
  if (!context) {
    throw new Error('useSalesforce must be used within a SalesforceProvider');
  }
  return context;
};
